module.exports = __webpack_public_path__ + "static/img/sec2-content@m.71006cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/sec2-content@m.png
// module id = LOfV
// module chunks = 0